import { CapoPlugin } from "/home/runner/work/immerhe.im/immerhe.im/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];